<template>
  <keep-alive include="myOrder" :exclude="[]">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {};
</script>

<style></style>